import {JSX} from "wfr/commons/jsx"
import {ENavLanguages, JLocInfos, L10nLabels, JCommonMetas} from "./api";
import {parseHtml} from "./commons"
import {styleSheet } from "wfr/commons/core";
import {SvcESSearch } from "wfr/search/essearch";
import {JHitSource} from "wfr/search/searchapi";

export {init, getMessages, JMessage, MessageBox, ELevel}

/**
 * Récupération, filtrage et construction des messages
 */

let es:SvcESSearch<JHitSource<JMessageSource>>

const	labels:L10nLabels = {
	//TODO supprimer les labels intdep si non nécessaire...
	[ENavLanguages.fr]: {
		warning:"Attention",
		intdep:"Compatible avec",
		"intdep-server":"Compatible avec",
		"intdep-application":"Compatible avec",
		"intdep-devtool":"Compatible avec",
		"intdep-extension":"Compatible avec",
		dep:"Dépendance"
	},
	[ENavLanguages.en]: {
		warning:"Warning",
		intdep:"Compatible with",
		"intdep-server":"Compatible with",
		"intdep-application":"Compatible with",
		"intdep-devtool":"Compatible with",
		"intdep-extension":"Compatible with",
		dep:"Dependence"
	}
}


interface JBindProduct{
	forProductKey?: string
	maxVersion?: string
	minVersion?: string
	forProductType?:string
	forExtType?:string
	grpCodes?:string[]
}
enum ELevel {
	info = "info",
	warning = "warning",
	intdep = "intdep",
	"intdep-server" = "intdep-server",
	"intdep-application" = "intdep-application",
	"intdep-devtool" = "intdep-devtool",
	"intdep-extension" = "intdep-extension",
	dep = "dep"
}
interface JMessageSource {
	level:ELevel,
	forProductMsg:JBindProduct[],
	locInfos:JLocInfos
}

interface JMessage extends JBindProduct{
	locInfos:JLocInfos
	level:ELevel
}

function init(downloadEsUrl: string) {
	es = new SvcESSearch(downloadEsUrl)
}

async function getMessages (metas:JCommonMetas): Promise<JMessage[]> {
	const queryProps:any = {"forProductMsg":{"forProductMsg.forProductKey":metas.productKey, "forProductMsg.forProductType":metas.productType}}
	if(metas.extType) queryProps.forProductMsg["forProductMsg.forExtType"] = metas.extType;

	const resp = await es.search("message", queryProps);
	const filteredMessages:JMessage[] = []
	resp.results.forEach(hit=>{
		for(let i = 0 ; i < hit._source.forProductMsg.length ; i++){
			const forProduct = hit._source.forProductMsg[i]
			if(forProduct.forProductKey && forProduct.forProductKey !== metas.productKey) continue;
			if(forProduct.forProductType && forProduct.forProductType !== metas.productType) continue;
			if(forProduct.forExtType && forProduct.forExtType !== metas.extType) continue;
			if(forProduct.minVersion && !matchMinVersion(forProduct.minVersion, metas)) continue;
			if(forProduct.maxVersion && !matchMaxVersion(forProduct.maxVersion, metas)) continue;
			const message:JMessage = forProduct as JMessage;
			message.level = hit._source.level
			message.locInfos = hit._source.locInfos
			filteredMessages.push(message)
		}
	});

	return filteredMessages
}

function matchMinVersion(minVersion:string, productInfos:any):boolean {
	if(!minVersion) return true
	const minV = minVersion.split(".").map(v=>parseInt(v))
	const piV = (productInfos.majorVersion + ("minorVersion" in productInfos?`.${productInfos.minorVersion}` : "")).split(".").map(v=>parseInt(v));
	for(let i = 0 ; i < Math.min(minV.length, piV.length) ; i++){
		if(minV[i] > piV[i]) return false;
	}
	return true;
}

function matchMaxVersion(maxVersion:string, productInfos:any):boolean {
	if(!maxVersion) return true
	const maxV = maxVersion.split(".").map(v=>parseInt(v));
	const piV = (productInfos.majorVersion + ("minorVersion" in productInfos?`.${productInfos.minorVersion}` : "")).split(".").map(v=>parseInt(v));
	for(let i = 0 ; i < Math.min(maxV.length, piV.length) ; i++){
		if(maxV[i] < piV[i]) return false;
	}
	return true;
}

class MessageBox extends HTMLElement{
	protected message:JMessage = null
	protected navLang:ENavLanguages = null

	constructor(message:JMessage, navLang:ENavLanguages) {
		super()
		this.message = message
		this.navLang = navLang
	}

	async connectedCallback() {
		this.attachShadow({mode: 'open'})
		this.shadowRoot!.adoptedStyleSheets.push(await styleSheet("./css/components.css"))

		if(!this.publishMessage()) return;

		this.shadowRoot.append(<div class={`message ${this.message.level}`}>
			<div class="head">
				{this.message.locInfos[this.navLang].title ? <span class="title">{this.message.locInfos[this.navLang].title}</span> : null}
				{this.message.level != "info" ? <span class="messageType">{this.s(this.message.level)}</span>:null}
			</div>

			{this.message.locInfos[this.navLang].body ? <div class="body">{parseHtml(this.message.locInfos[this.navLang].body)}</div>: null}

			{this.addMessageContent()}
		</div>)
	}

	/**
	 * À surcharger pour ne pas publier de message
	 * @protected
	 */
	protected publishMessage():boolean{
		return true
	}

	/**
	 * À surcharger pour injection de contenu dans les messages.
	 * @protected
	 */
	protected addMessageContent():Element{
		return null;
	}

	protected s(key:string) {
		return labels[this.navLang][key] as string;
	}
}

customElements.define('message-box', MessageBox)

